import React, { Component } from "react"
import { connect } from 'react-redux'
import $ from 'jquery'

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from "@material-ui/core/TablePagination";
import TableSortLabel from "@material-ui/core/TableSortLabel";

import {
    getIOAction,
    getIOPmOrderAction
} from '../../redux/actions/MasterAction'

import { msg } from '../../components/Notifications/MsgBox';

import { startLoadingAction, stopLoadingAction } from "../../redux/actions/AppAction.js"

class SearchIOModal extends Component {

    constructor(props) {
        super(props)

        this.state = {
            // ...props,
            selectedTab: "io",
            q_auart:'',
            q_processingGrp:'',
            q_description:'',
            q_orderNumber:'',
            q_searchCostCenter:'',
            q_searchIo:'',
            ioDatas: [],
            page: 0,
            rowsPerPage: 5,
            totalRecord:0,
            order: "asc",
            orderBy: "",
            q_pmOrderNo: "",
            q_pmOrderDesc:"",
        }
        this.handleClick = this.handleClick.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.handleChangePage = this.handleChangePage.bind(this)
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this)
        this.selecctIO = this.selecctIO.bind(this)
        this.handlePmOrderClick = this.handlePmOrderClick.bind(this)
    }

    selecctIO(obj){
        window.$('#searchIOModal').modal('hide')
        this.props.onSelectIO(obj.ordeR_NUMBER)
    }

    handleChangeTab(tab){
        this.setState({
            selectedTab:tab,
        })
        $(function () {
            window.onComponentDidMount()
        })
    }

    handleChange(event) {
        const { name, value } = event.target
        this.setState({
            [name]: value,
        })
    }

    async handleClick(event, newPage){

        let {q_auart,q_processingGrp,q_description,q_orderNumber,q_searchCostCenter,q_searchIo,page,rowsPerPage} = this.state;
        this.props.startLoading()
        if(newPage)
        {
            page = newPage
        }else{
            page = 0
        }
        await this.props.getIO(q_auart,q_processingGrp,q_description,q_orderNumber,q_searchCostCenter,q_searchIo,page*rowsPerPage,rowsPerPage)
        .then(async response => {
            if(response.data !== ""){
                await this.setState({
                    ioDatas:response.data,
                    totalRecord:response.data[0].totaL_ROW,
                    page:page,
                    rowsPerPage: rowsPerPage
                })
            }else{
                await this.setState({
                    ioDatas:[],
                    totalRecord:0,
                    page:page,
                    rowsPerPage: rowsPerPage
                })

            }

            this.props.stopLoading()
        });    
        if(this.state.ioDatas.length === 0){
            msg.error("ไม่พบข้อมูล")
        }
    }

    async handlePmOrderClick(event, newPage){

        let {q_pmOrderNo,q_pmOrderDesc,page,rowsPerPage} = this.state;

        this.props.startLoading()

        this.props.startLoading()
        if(newPage)
        {
            page = newPage
        }else{
            page = 0
        }
        await this.props.getIOPmOrder(q_pmOrderNo,q_pmOrderDesc,page*rowsPerPage,rowsPerPage)
        .then(async response => {
            if(response.data !== ""){
                await this.setState({
                    ioDatas:response.data,
                    totalRecord:response.data[0].totaL_ROW,
                    page:page,
                    rowsPerPage: rowsPerPage
                })
            }else{
                await this.setState({
                    ioDatas:[],
                    totalRecord:0,
                    page:page,
                    rowsPerPage: rowsPerPage
                })

            }

            this.props.stopLoading()
            
        });    
        if(this.state.ioDatas.length === 0){
            msg.error("ไม่พบข้อมูล")
        }
    }

    // Grid start
    desc(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    stableSort(array, cmp) {
        if (typeof (array) !== "undefined") {
            const stabilizedThis = array.map((el, index) => [el, index]);
            stabilizedThis.sort((a, b) => {
                const order = cmp(a[0], b[0]);
                if (order !== 0) return order;
                return a[1] - b[1];
            });
            return stabilizedThis.map(el => el[0]);
        }
    }

    getSorting(order, orderBy) {
        return order === "desc"
            ? (a, b) => this.desc(a, b, orderBy)
            : (a, b) => -this.desc(a, b, orderBy);
    }

    handleRequestSort(event, property) {
        const isDesc = this.state.orderBy === property && this.state.order === "desc";
        this.setState({
            order: isDesc ? "asc" : "desc",
            orderBy: property
        })
    }

    async handleChangePage(event, newPage) {
        await this.setState({
            page: newPage
        })
        if(this.state.selectedTab === "pm"){
            this.handlePmOrderClick(event, newPage)
        }else{
            this.handleClick(event, newPage)
        }
    }

    async handleChangeRowsPerPage(event) {
        await this.setState({
            rowsPerPage: event.target.value,
            page: 0
        })
        if(this.state.selectedTab === "pm"){
            this.handlePmOrderClick()
        }else{
            this.handleClick()
        }
    }

    // Grid end

    render() {
        let {ioDatas, q_auart,q_processingGrp,q_description,q_orderNumber,q_searchCostCenter,q_searchIo, q_pmOrderNo,q_pmOrderDesc, page, rowsPerPage, totalRecord,order,orderBy} = this.state

        return (
            <div className="modal fade sp-modal rrs-modal" id="searchIOModal" tabIndex={-1} role="dialog" aria-labelledby="searchIOModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchIOModalLabel">ค้นหาข้อมูล Order</h5>
                            <button type="button" className="close" onClick={()=>window.$('#searchIOModal').modal('hide')} aria-label="Close">
                                <span aria-hidden="true">×</span>
                            </button>
                        </div>
                        <div className="modal-body rrs-container" style={{paddingTop: "20px"}}>
                            <div className="rrs-detail3" id="tabContainer">
                             
                                {/* tab button */}
                                <div className="row">
                                    <div className="col-md-6 sp-project-panel">
                                        <a href="#" className="sp-project-modal-link" id="ioNav" onClick={() => this.handleChangeTab('io')} data-toggle="collapse" data-target="#ioTab" aria-expanded="true" aria-controls="ioTab">                                        
                                            <span>IO</span>
                                        </a>
                                    </div>
                                    <div className="col-md-6 sp-project-panel">
                                        <a href="#" className="sp-project-modal-link collapsed" id="pmNav" onClick={() =>this.handleChangeTab('pm')} data-toggle="collapse" data-target="#pmTab" aria-expanded="false" aria-controls="pmTab">
                                            <span>PM Order</span>
                                        </a>
                                    </div>
                                </div>
                                
                                {/* tab io */}
                                <div className="rrs-container-wrap collapse show" id="ioTab" aria-labelledby="ioNav" data-parent="#tabContainer">
                                    <div className="rrs-container" style={{paddingTop:"29px"}}>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="rrs-form">

                                                    <label htmlFor="txtEmpCode" className="rrs-label">Order No.</label>
                                                    <div className="rrs-detail-data">
                                                        <input autoComplete="off" type="text" className="form-control w-500"  placeholder="Order No." id="q_orderNumber" name="q_orderNumber"  onChange={this.handleChange} value={q_orderNumber} />
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-6">
                                            <div className="rrs-form">

                                                <label htmlFor="txtEmpCode" className="rrs-label">Description</label>
                                                <div className="rrs-detail-data">
                                                    <input type="text" className="form-control w-500"  placeholder="Description" id="q_description" name="q_description"  onChange={this.handleChange} value={q_description} />
                                                </div>

                                            </div>
                                        </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="rrs-form">

                                                    <label htmlFor="txtEmpCode" className="rrs-label">Order Type</label>
                                                    <div className="rrs-detail-data">
                                                        <input type="text" className="form-control w-500"  placeholder="Order Type" id="q_auart" name="q_auart"  onChange={this.handleChange} value={q_auart} />
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-6">
                                            <div className="rrs-form">

                                                <label htmlFor="txtEmpCode" className="rrs-label">Cost Center</label>
                                                <div className="rrs-detail-data">
                                                    <input type="text" className="form-control w-500"  placeholder="Cost Center" id="q_searchCostCenter" name="q_searchCostCenter"  onChange={this.handleChange} value={q_searchCostCenter} />
                                                </div>

                                            </div>
                                        </div>
                                        </div>
                                        <div className="col-12" style={{textAlign:"center",paddingBottom:"10px",paddingTop:"5px"}}>
                                        <button className="rrs-btn-icon" onClick={this.handleClick}><i className="icon bt-search icon-xs"></i></button>
                                        </div>
                                        </div>
                                        
                                    </div>
                                {/* end tab io */}
                                
                                {/* tab pm */}
                                <div className="rrs-container-wrap collapse" id="pmTab" aria-labelledby="pmNav" data-parent="#tabContainer">
                                    <div className="rrs-container" style={{paddingTop:"29px"}}>
                                        <div className="row">
                                            <div className="col-6">
                                                <div className="rrs-form">

                                                    <label htmlFor="txtEmpCode" className="rrs-label">Order No.</label>
                                                    <div className="rrs-detail-data">
                                                        <input type="text" className="form-control w-500"  placeholder="Order No." id="q_pmOrderNo" name="q_pmOrderNo"  onChange={this.handleChange} value={q_pmOrderNo} />
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="col-6">
                                                <div className="rrs-form">

                                                    <label htmlFor="txtEmpCode" className="rrs-label">Description</label>
                                                    <div className="rrs-detail-data">
                                                        <input type="text" className="form-control w-500"  placeholder="Description" id="q_pmOrderDesc" name="q_pmOrderDesc"  onChange={this.handleChange} value={q_pmOrderDesc} />
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-12" style={{textAlign:"center",paddingBottom:"10px",paddingTop:"5px"}}>
                                        <button className="rrs-btn-icon" onClick={this.handlePmOrderClick}><i className="icon bt-search icon-xs"></i></button>
                                        </div>
                                        </div>
                                        <div className="row no-gutters sp-table-content">

                                        </div>
                                    </div>
                                
                                {/* end tab pm */}
                            {/* </div> */}
                            </div>
                        </div>
                                 
                        {/* table */}
                        <div className="row no-gutters sp-table-content">
                            <div className="col-12">
                                
                                <Table aria-labelledby="tableTitle" className="sp-table table rrs-table">
                                    <TableHead>
                                        <TableRow className="sp-table-header">
                                            <TableCell className="th-table text-center">
                                                Order
                                            </TableCell>
                                            <TableCell className="th-table text-center">
                                                Description
                                            </TableCell>
                                            <TableCell className="th-table text-center">
                                                
                                            </TableCell>
                                            
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {this.stableSort(ioDatas, this.getSorting(this.state.order, this.state.orderBy))
                                            //.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                            .map((row, index) => {
                                                //console.log("SearchAssetModal", page)                                                    
                                                //console.log(assetDatas)                                                    
                                                return (
                                                    <TableRow
                                                        hover
                                                        tabIndex={-1}
                                                        key={row.ordeR_NUMBER}
                                                    >
                                                        <TableCell className="action-icon">
                                                            {row.ordeR_NUMBER}
                                                        </TableCell>
                                                        <TableCell className="action-icon text-left">
                                                            {row.description}
                                                        </TableCell>
                                                        <TableCell className="action-icon">
                                                            <button className="btn btn-info btn-choose-item" aria-label="Close" onClick={() => this.selecctIO(row)}>
                                                                เลือก
                                                            </button> 
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            })
                                        }
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    className="pager"
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={totalRecord}
                                    rowsPerPage={this.state.rowsPerPage}
                                    page={this.state.page}
                                    backIconButtonProps={{
                                        "aria-label": "previous page"
                                    }}
                                    nextIconButtonProps={{
                                        "aria-label": "next page"
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </div>

                            </div>
                        {/* end table */}

                    </div>
                </div>

            </div>
        )
    }
}

const mapStateToProps = state => {
    const { MainRedux, MasterRedux, ModalVendorRedux } = state
    return {

    }
}
  
  const mapDispatchToProps = dispatch => {
    return {
        getIO: (auart, processingGrp, description, orderNumber, searchCostCenter, searchIo, offset, limit) => dispatch(getIOAction(auart, processingGrp, description, orderNumber, searchCostCenter, searchIo, offset, limit)),
        getIOPmOrder:(order_no, order_disc, offset, limit) => dispatch(getIOPmOrderAction(order_no, order_disc, offset, limit)),
        startLoading: () => dispatch(startLoadingAction()),
        stopLoading: () => dispatch(stopLoadingAction()),
    }
  }
  
  export default connect(
    mapStateToProps,
    mapDispatchToProps
  )(SearchIOModal)